module.exports = __webpack_public_path__ + "media/images/lp-form-decoration-3a1040df085eceebc70fc6ec75dd1b59.svg";